/**
 * Deterministická paleta barev per vozidlo. Použito pro Live mapu — marker
 * objednávky, polyline plánu (dashed) i polyline aktuální trasy (solid)
 * nese barvu svého vozidla, ať uživatel rozezná auta na první pohled.
 *
 * Cool spektrum — záměrně vyřazené semafor barvy (green/amber/red/orange/yellow)
 * a violet #8B5CF6 (pin bistra, aby barva auta s sídlem nekolidovala). Pořadí
 * je „interleave po color-wheel" — sousední indexy mají maximální hue distance
 * (blue↔pink, cyan↔fuchsia), takže fleet 2-4 aut má vždy vizuálně rozdílné
 * markery. Bez tohoto interleave dostávaly auta s ID 1+2 cyan+teal (=
 * neodlišitelné). Sjednoceno s POS VD paletou.
 */
export const VOZIDLO_PALETTE = [
    '#3B82F6', // blue         240°
    '#EC4899', // pink         330°
    '#06B6D4', // cyan         190°
    '#D946EF', // fuchsia      290°
    '#0EA5E9', // sky          200°
    '#F472B6', // light pink   330°
    '#14B8A6', // teal         175°
    '#818CF8', // light indigo 235°
];

export function vozidloColor(id) {
    return VOZIDLO_PALETTE[Math.abs(Number(id || 0)) % VOZIDLO_PALETTE.length];
}
